/**
 * GOAL CREATION SUCCESS BADGE
 * 
 * Displays a styled success message when goal creation pipeline completes.
 * Styled similarly to personality sliders confirmation element.
 * 
 * Date: December 29, 2025
 */

import React from 'react';
import { Check } from 'lucide-react';

interface GoalCreationSuccessBadgeProps {
  goalText: string;
  goalDetails?: string;
}

export const GoalCreationSuccessBadge: React.FC<GoalCreationSuccessBadgeProps> = ({
  goalText,
  goalDetails
}) => {
  return (
    <div className="bg-gradient-to-r from-emerald-50 to-teal-50 border-2 border-emerald-200 rounded-xl p-5 my-4 shadow-sm">
      {/* Header with checkmark */}
      <div className="flex items-start gap-3 mb-3">
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
            <Check className="w-5 h-5 text-white stroke-[3]" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-1">
            Goal profile, framework and this week's plan completed
          </h3>
          <p className="text-sm text-gray-700">
            Your {goalText}{goalDetails && ` ${goalDetails}`} is ready!
          </p>
        </div>
      </div>

      {/* Success details */}
      <div className="ml-11 space-y-2">
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
          <span>Goal profile with research-backed insights</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
          <span>Training framework with phases and milestones</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full"></div>
          <span>This week's workout plan</span>
        </div>
      </div>

      {/* Call to action */}
      <div className="mt-4 ml-11 pt-3 border-t border-emerald-200">
        <p className="text-sm text-gray-700 font-medium">
          Check out the <span className="text-cedar-green font-semibold">Move</span> section to see your full plan!
        </p>
      </div>
    </div>
  );
};





